<template>
  <div>
    <!-- {{isSidebarActiveLocal}} -->
    <vs-popup
      classContent="popup-example"
      title="Create Staff"
      class="add-new-data-sidebar items-no-padding no-scroll-sidebar medium fixed_medium"
      :active.sync="isSidebarActiveLocal"
    >
      <!-- <div class="mt-6 flex items-center justify-between px-6">
        <h4>Add Staff</h4>
      </div>
      <vs-divider class="mb-0" /> -->
      <!-- Changes made by Sujay Ghosh(06-07-2020) -->
      <form data-vv-scope="add_user" class="sidebar-scrollable-form px-4">
        <div class="vx-row">
          <span style="color: green">{{ api_response_message }}</span>
          <div class="add_form_holder flex flex-wrap">
              <template v-for="field in staticFields">
                <div class="p-1" :class="slugify(field.field_label) == 'first-name' || slugify(field.field_label) == 'middle-name' || slugify(field.field_label) == 'last-name' ? 'lg:w-1/3 sm:w-full' : slugify(field.field_label).includes('address') || slugify(field.field_label).includes('role-name') ? 'w-full' : 'lg:w-1/2 sm:w-full'" :key="field.id">
                  <label class="vs-input--label w-full"
                    >{{ field.field_label
                    }}<span v-if="field.enabled_parent" class="required"></span
                  ></label>
                  <vs-input
                    v-if="
                      field.field_name != 'platform_customer_countries_id' &&
                      field.field_name != 'user_roles_id' &&
                      field.is_address_field == 1
                    "
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    v-model="user.address[field.field_name]"
                    class="custom_Input"
                    :name="field.field_label"
                    style="width: 100%"
                  />
                  <vs-input
                    v-if="
                      field.field_name != 'platform_customer_countries_id' &&
                      field.field_name != 'user_roles_id' &&
                      field.is_address_field != 1
                    "
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    v-model="user[field.field_name]"
                    class="custom_Input"
                    :name="field.field_label"
                    style="width: 100%"
                    
                  />
                  <v-select
                    v-if="
                      field.field_name == 'platform_customer_countries_id' &&
                      field.is_address_field == 1
                    "
                    v-model="user.address[field.field_name]"
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    :reduce="(option) => option.id"
                    label="country_name"
                    :name="field.field_label"
                    :options="countryList"
                    style="width: 100%"
                  />
                
                    <v-select
                    v-if="
                      field.field_name == 'user_roles_id'"
                    v-model="user[field.field_name]"
                    v-validate="field.enabled_parent == true ? 'required' : ''"
                    :reduce="(option) => option.user_role_id"
                    label="role_name"
                    :data-vv-name="field.field_label"
                    :name="field.field_label"
                    :options="user.roleList"
                  
                    style="width: 100%"
                  />
                  <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="field.field_label=='Phone'">
                      <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
                  </div>
                  <!-- <div class="flex items-center" style="color: rgba(var(--vs-primary), 1); font-size: 12px;" v-if="field.field_label=='Phone'">
                      <span style="font-size: 14px; margin-right: 2px;" class="material-icons-outlined">info</span>Country code is mandatory.
                  </div>  -->
                  <span
                    v-show="errors.has(`add_user.${field.field_label}`)"
                    class="text-danger"
                    >{{ errors.first(`add_user.${field.field_label}`) }}</span
                  >
                </div>
              </template>

              <!-- For Dynamic Field required Labels-->
              <div class="w-full mt-2">
                <dynamic-component
                  ref="children"
                  :custom_fields_required="custom_fields_required"
                  validatorScope="add_user"
                  v-model="dynamicFormObject"
                ></dynamic-component>
              </div>

          </div>
        </div>
        <div class="text-center mt-5">
          <vs-button
            color="primary"
            type="filled"
            class="mr-3"
            @click="create_user('saveandclose')"
            >Save</vs-button
          >
        </div>
      </form>
      <!-- End chnages made by Sujay Ghosh -->
    </vs-popup>
  </div>
</template>

<script>
import DynamicComponent from '@/components/common/DynamicComponent'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import { role_list, create_user } from '@/api/user'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    DynamicComponent,
    flatPickr,
    vSelect
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          /* this.$validator.errors.clear('Add_Lead')
          this.$refs.children.$validator.errors.clear('Add_Lead') */
          this.$validator.reset()
          this.$refs.children.$validator.reset()
          this.$emit('closeSidebar', false)
        }
      }
    }
  },
  props: {
    isSidebarActive: {},
    custom_fields_required: {
      type: Array,
      required: true,
      default: () => []
    },
    countryList: {
      type: Array,
      required: true,
      default: () => []
    },
    dynamicFormObject: {
      type: Object,
      required: true,
      default: () => {}
    },
    staticFields: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      user: {
        roleList: [],
        middle_name: '',
        first_name: '',
        email: '',
        phone: '',
        last_name: '',
        user_roles_id: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          state: '',
          platform_customer_countries_id: 1,
          zip: ''
        }
      },

      errorCount: 0,
      api_response_message_show: false,
      api_response_message: ''
    }
  },
  async created () {
    const data = await this.fetchRoleList('custom')
    if (data) {
      this.fetchRoleList('system')
    }

    /* role_list(localStorage.getItem('customer_id'), paramspayload)
      .then((res) => {
        
        this.options1 = res.data.data.role_list
      })
      .catch((e) => {
        
      }) */
  },
  methods: {
    slugify (string) {
      return string ? string
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/[^\w-]+/g, '') : ''
    },
    async fetchRoleList (type) {
      try {
        const paramspayload = {
          type
        }
        const res = await role_list(
          this.$store.getters.customerId,
          paramspayload
        )

        this.user.roleList = [
          ...this.user.roleList,
          ...res.data.data.role_list
        ]
        return true
        // this.fetchRoleList('system')
      } catch (error) {}
    },
    create_user (sidebar_close_status) {
      this.api_response_message_show = false
      const validateParent = this.$validator.validateAll('add_user')
      const childDynamicComponent =
        this.$refs.children.$validator.validateAll('add_user')
      const validateAll = Promise.all([validateParent, childDynamicComponent])
      validateAll.then((valid) => {
        if (!valid.includes(false)) {
          // const request_parameter = {
          //   first_name: this.first_name,
          //   middle_name: this.middle_name,
          //   last_name: this.last_name,
          //   phone: this.phone,
          //   email: this.email,
          //   user_roles_id: this.user_roles_id,
          //   address: {
          //     address1: this.address.address1,
          //     address2: this.address.address2,
          //     state: this.address.state,
          //     city: this.address.city,
          //     zip: this.address.zip,
          //     platform_customer_countries_id: this.address
          //       .platform_customer_countries_id
          //   }
          // }

          this.creatingUser(this.user, sidebar_close_status)

          this.showSuccessMessage(
            'Success',
            'Staff created Successfully',
            'success'
          )
        } else {
          this.showSuccessMessage(
            'Error',
            'All required Fields Are Mandatory',
            'danger'
          )
        }
      })

      // this.showSuccessMessage('Error', 'All Fields Are Mandatory', 'danger')
    },
    async creatingUser (request_parameter, sidebar_close_status) {
      try {
        const attchedDynamicFieldObject = {
          dynamic_fields: {}
        }
        attchedDynamicFieldObject.dynamic_fields = this.dynamicFormObject

        //assigning form values into object dynamic fields

        //
        const parameter = Object.assign(
          {},
          request_parameter,
          attchedDynamicFieldObject
        )
        const response = await create_user(
          localStorage.getItem('customer_id'),
          parameter
        )

        const userObject = response.data.data.operationalUser

        this.setDefault()

        if (sidebar_close_status === 'saveandclose') {
          userObject.saveType = 'SaveAndClose'
          this.$emit('closeSidebar', userObject)
        } else if (sidebar_close_status === 'saveandaddanother') {
          userObject.saveType = 'SaveAndAnother'
          this.$emit('closeSidebar', userObject)
        } else {
          const userId = userObject.basic_details.operation_user_id

          //temp changes
          setTimeout(() => {
            this.$router.push({
              name: 'user-profile',
              params: { teacher_id: userId }
            })
          }, 0)
        }
      } catch (api_error) {
        for (const [key, value] of Object.entries(api_error.data.errors)) {
          this.showSuccessMessage('Error', `${value[0]}`, 'danger')
        }
      }
    },
    setDefault () {
      this.user.first_name = ''
      this.user.email = ''
      this.user.phone = ''
      this.user.last_name = ''
      this.user.user_roles_id = ''
      this.user.address.address1 = ''
      this.user.address.address2 = ''
      this.user.address.state = ''
      this.user.address.city = ''
      this.user.address.zip = ''
      this.user.address.platform_customer_countries_id = 225

      this.errorCount = 0
      this.api_response_message_show = ''
      this.api_response_message = ''
      //   for(let eachObject,key) in this.dynamicFormObject)
      Object.keys(this.dynamicFormObject).forEach((key, value) => {
        this.dynamicFormObject[key] = ''
      })
      this.$validator.reset()
    }
  }
}
</script>
<style scoped>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}

.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}

.vs-notifications {
  z-index: 1111111111111151111 !important;
}

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
/* .ag-header-cell {
    padding: 2px !important;
  } */

.custom-btn1 {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 0px;
  font-weight: 600;
}
.ag-pivot-off .ag-header-group-cell {
  /* font-size: 50px; */
  color: red;
}
.ag-grid-table {
  min-height: 250px;
}

li {
  list-style: none;
}
#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.requiredInput .vs-input--label:after {
  content: " *";
  color: red;
}

.required:after {
  content: " *";
  color: red;
}
/* .vs-sidebar .vs-sidebar--items {
  overflow-y: scroll;
} */
.select_custom {
  height: 40px;
  border: none;
  background-color: white;
  border: 1px solid #cccccc;
  color: #787878;
  font-size: 14px;
  width: 100%;
  border-radius: 5px;
}
</style>
